// import logo from './logo.svg';
// import './App.css';
// import CVIndex from "./pages/CVIndex";

function App() {
  return null;
  //return <CVIndex />;
}

export default App;
